import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    ricette: [],
    isLoading: false,
    error: null,
    tipo: [],
    enumsLoading: {
        tipo: false,
    },
    enumsError: {
        tipo: null,
    }
}
const ricetteSlice = createSlice({
    name: "mezziData",
    initialState,
    reducers: {
      setRicette: (state, action) => {
        state.ricette = action.payload;
        // console.log("setProdotti - New prodotti:", state.mezzi);
      },
      addRicette: (state, action) => {
        state.ricette.push(action.payload);
      },
      
      apiRequestStart: (state) => {
        state.isLoading = true;
        state.error = null;
      },
      apiRequestSuccess: (state) => {
        state.isLoading = false;
      },
      apiRequestFailure: (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      },
      setTipo: (state, action) => {
        state.tipo = action.payload;
      },
      enumRequestStart: (state, action) => {
        state.enumsLoading[action.payload] = true;
        state.enumsError[action.payload] = null;
      },
      enumRequestSuccess: (state, action) => {
        state.enumsLoading[action.payload] = false;
      },
      enumRequestFailure: (state, action) => {
        const { enumType, error } = action.payload;
        state.enumsLoading[enumType] = false;
        state.enumsError[enumType] = error;
      }
    },
  });
  export const {
    setRicette,
    addRicette,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    enumRequestFailure,
    enumRequestStart,
    enumRequestSuccess,
    setTipo,
  } = ricetteSlice.actions;
  // Fix the selectors to consistently use prodottoData
  // Fix the selectors to consistently use the same state path
  export const selectRicette = (state) => state.ricette?.ricette;
//   export const selectSingleMezzi = (state) => state.mezzi?.singleMezzi;
  export const selectIsLoading = (state) => state.ricette?.isLoading;
  export const selectError = (state) => state.ricette?.error;
  export const selectTipo = (state) => state.ricette?.tipo;
  export default ricetteSlice.reducer;